import { render, staticRenderFns } from "./BrandIdBlock.vue?vue&type=template&id=537611a6&scoped=true"
import script from "./BrandIdBlock.vue?vue&type=script&lang=js"
export * from "./BrandIdBlock.vue?vue&type=script&lang=js"
import style0 from "./BrandIdBlock.vue?vue&type=style&index=0&id=537611a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537611a6",
  null
  
)

export default component.exports